import { useCallback } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';
import {
	FormViewMode,
	useFormIndexActions,
	useSelectedFormStoreState,
} from '@atlassian/proforma-form-system';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';

export const useHandleCancelEditForm = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { setFormViewMode, reportError } = useFormIndexActions();
	const { selectedFormStore } = useSelectedFormStoreState();

	return useCallback(() => {
		try {
			if (!selectedFormStore) {
				return;
			}
			selectedFormStore.discardModifiedAnswers();
			selectedFormStore.hideValidations();
			setFormViewMode(FormViewMode.View);
			fireTrackAnalytics(createAnalyticsEvent({}), `${ActionSubject.FORM_EDIT} ${Action.STOPPED}`, {
				formId: selectedFormStore.formId,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			reportError(error, {
				id: 'cancelEditForm',
				attributes: { formId: selectedFormStore?.formId },
			});
			throw error;
		}
	}, [createAnalyticsEvent, reportError, selectedFormStore, setFormViewMode]);
};
